<script setup lang="ts">
import { useSessionTimeout } from '@/modules/core/composables/useSessionTimeout'
import SessionTimeoutWarning from '@/modules/core/components/SessionTimeoutWarning.vue'

const { showWarning, remainingSeconds, extendSession } = useSessionTimeout()
</script>

<template>
  <router-view />
  <SessionTimeoutWarning
    :visible="showWarning"
    :remaining-seconds="remainingSeconds"
    @extend="extendSession"
  />
</template>

<style scoped></style>
